import { addToChainAfter, createHandlerChainRunner, HandlerWithResult } from "@insite/client-framework/HandlerCreator";
import { AddPriceFilters,chain } from "@insite/client-framework/Store/Pages/ProductList/Handlers/AddProductFilters";
import { ProductFilters } from "@insite/client-framework/Store/Pages/ProductList/ProductListState";


export interface CustomProductFilters extends ProductFilters {
    minimumPrice?:string
}

type HandlerType = HandlerWithResult<CustomProductFilters, CustomProductFilters>;

export const AddMinimumPrice: HandlerType = props => {
    const currentFilters: CustomProductFilters = props.getState().pages.productList.productFilters;
    props.result.minimumPrice = currentFilters.minimumPrice;
    if (props.parameter.minimumPrice) {
        props.result.minimumPrice = props.parameter.minimumPrice;
    }
};


addToChainAfter(chain,AddPriceFilters,AddMinimumPrice);